
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Settings from "../../modules/settings/Settings";
export default Settings;
export function getStaticPaths({ locales = [], }: {
    locales?: string[];
}) {
    const russianFallbackPaths = locales.includes("ru")
        ? [0, 1, 2, 3, 4, 5, 6].map((page) => ({
            params: { page: page.toString() },
            locale: "ru",
        }))
        : [];
    return {
        // Settings pages are private utility routes. Build them on first request
        // while retaining Russian HTML for the static Yandex fallback.
        paths: russianFallbackPaths,
        fallback: "blocking",
    };
}
const getStaticProps = async ({ params }) => {
    const { page } = params;
    return {
        props: { page },
    };
};

    async function __Next_Translate__getStaticProps__1a179dc90ad__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/settings/[page]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a179dc90ad__ as getStaticProps }
  